import { render, staticRenderFns } from "./oma.vue?vue&type=template&id=2229a790&scoped=true"
import script from "./oma.vue?vue&type=script&lang=js"
export * from "./oma.vue?vue&type=script&lang=js"
import style0 from "./oma.vue?vue&type=style&index=0&id=2229a790&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2229a790",
  null
  
)

export default component.exports